import { useId } from 'react';
import './Input.css';

/**
 * Поле вводу — ADR-0008.
 *
 * Підпис стоїть НАД полем і зв'язаний через for/id. Плаваючий підпис, який
 * підмінював placeholder, прибрано: він недоступний і губиться при автозаповненні.
 * Помилка виводиться під полем із role="alert".
 */
export default function Input({
  labelText,
  placeholderText,
  helperText,
  errorText,
  inputClassName,
  labelClassName,
  className = '',
  id,
  name,
  type,
  textarea,
  ...props
}) {
  const generatedId = useId();
  const fieldId = id || `${name || 'field'}-${generatedId}`;
  const helperId = `${fieldId}-helper`;
  const errorId = `${fieldId}-error`;
  const Tag = textarea ? 'textarea' : 'input';

  const describedBy = [helperText ? helperId : null, errorText ? errorId : null].filter(Boolean).join(' ') || undefined;

  return (
    <div className={`form-control ${errorText ? 'has-error' : ''} ${className}`}>
      {labelText && (
        <label className={`label ${labelClassName || ''}`} htmlFor={fieldId}>
          {labelText}
        </label>
      )}
      <Tag
        {...props}
        id={fieldId}
        name={name}
        className={`input ${inputClassName || ''}`}
        type={textarea ? undefined : type || 'text'}
        placeholder={placeholderText || ''}
        aria-invalid={errorText ? 'true' : undefined}
        aria-describedby={describedBy}
      />
      {helperText && !errorText && (
        <span className='field-helper' id={helperId}>
          {helperText}
        </span>
      )}
      {errorText && (
        <span className='field-error' id={errorId} role='alert'>
          {errorText}
        </span>
      )}
    </div>
  );
}
